import React from 'react';
import CloseCircle from '@elliemae/ds-icons/CloseCircle';
import DSButton from '@elliemae/ds-button';

/* eslint-disable react/destructuring-assignment,max-lines,react/display-name, react/require-default-props */

var ClearIndicator = function ClearIndicator(props) {
  var getStyles = props.getStyles,
      ref = props.innerProps.ref,
      innerRef = props.innerRef;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "aria-hidden": "false",
    style: getStyles('clearIndicator', props)
  }, /*#__PURE__*/React.createElement(DSButton, {
    "aria-label": "clear-indicator",
    buttonType: "text",
    className: "clear-indicator",
    icon: /*#__PURE__*/React.createElement(CloseCircle, {
      size: "m"
    }),
    innerRef: innerRef,
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        e.preventDefault();
        props.clearValue();
      }

      props.onKeyDown(e);
    }
  }));
};

export default ClearIndicator;
//# sourceMappingURL=ClearIndicator.js.map
